module.exports = __webpack_public_path__ + "assets/Retina-Light.64f86fb2a376ce3b352246204acb8520.woff";